/**
 * Retrieves a template from the template library by its ID.
 *
 * @param {Number} templateID - The unique identifier of the template to retrieve.
 * @return {Object|undefined} The template object if found, or `undefined` if no template matches the given ID.
 */
const getTemplate = templateID => {
	return UncannyAutomatorBackend.templateLibrary.templates.find(
		template => template.id === templateID
	);
};

export default getTemplate;
